import dayjs from 'dayjs'
import localizedFormat from 'dayjs/plugin/localizedFormat'

// Import necessary locales
import 'dayjs/locale/en' // English
// import 'dayjs/locale/es' // Spanish
import 'dayjs/locale/uk' // Ukrainian

dayjs.extend(localizedFormat)

const setDayjsLocale = (language) => {
  dayjs.locale(language) // Dynamically set the locale
}

export { dayjs, setDayjsLocale }
